import React, { useState } from "react";

import Navbar from "./navbar";
import Home from "./home";
import Client from "./client";
import Services from "./services";
import Features from "./features";
import Plans from "./plans";
import Faqs from "./faq";
import Reviews from "./reviews";
import Counter from "./counter";
import WorkProcess from "./workProcess";
import Team from "./team";
import Contact from "./contact";
import Cta from "./cta";
import Footer from "./footer";
import { ethereum } from "../../../Components/ConnectMetamaskButton/networks";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Index = () => {
  document.title = " Multisend | Fort Exchange";

  window.onscroll = function () {
    scrollFunction();
  };

  const scrollFunction = () => {
    const element = document.getElementById("back-to-top");
    if (element) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        element.style.display = "block";
      } else {
        element.style.display = "none";
      }
    }
  };

  const toTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const [networkConfig, setNetworkConfig] = useState(ethereum);
  const [isConnected, setIsConnected] = useState(false);

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="layout-wrapper landing">
        <Navbar
          networkConfig={networkConfig}
          setIsConnected={setIsConnected}
          isConnected={isConnected}
        />
        <Home />
        <Contact
          networkConfig={networkConfig}
          setNetworkConfig={setNetworkConfig}
          setIsConnected={setIsConnected}
          isConnected={isConnected}
        />
        {/* <Faqs /> */}
        <Cta />
        <Footer />
        <button
          onClick={() => toTop()}
          className="btn btn-danger btn-icon landing-back-top"
          id="back-to-top"
        >
          <i className="ri-arrow-up-line"></i>
        </button>
      </div>
    </React.Fragment>
  );
};

export default Index;
